import { http } from '@/libs/util'
import util from '@/libs/util'
export const { 
    customer_salary_adjust_apply_search,
    customer_salary_adjust_apply_detail,
    customer_salary_payment_apply_search
 
 } = util.api || {}
 // customer_salary_adjust_apply_search
 export function getCustomerSalaryAdjustApplySearchApi(params) {
    return http.get(customer_salary_adjust_apply_search, params)
}

export function getCustomerSalaryAdjustApplyDetailApi(params) {
    return http.get(customer_salary_adjust_apply_detail, params)
}

export function getCustomerSalaryPaymentApplySearchApi(params) {
    return http.get(customer_salary_payment_apply_search, params)
}
